import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import {breakpoints} from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  filter: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    width: "fit-content",
    display: "inline-block",
    color: colors.lightBlack
  },
  selectDates: {
    marginRight: "12px",
    display: "flex",
    color: theme.flatpickr.selectDates.color,
    alignItems: "center",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: 0,
      width: "100%",
      justifyContent: "center"
    },
  },
  popoverContainer:{
    display:"flex",

  },
  popoverDiv:{
    display:"flex",
    maxWidth:"848px",
    width: "fit-content",
    backgroundColor: theme.flatpickr.popoverDiv.backgroundColor,
    border: theme.flatpickr.popoverDiv.border,
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    borderRadius: 8,
    color: theme.flatpickr.popoverDiv.color,
    flexDirection: "column",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width:"auto",
    },
  },
  flat:{
    padding:"0px 24px 0px 24px",
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      padding: 0
    },
    "& input": {
      display: "none"
    },
    "& .flatpickr-months": {
      "& .flatpickr-month": {
        marginTop: "20px"
      },
      "& .flatpickr-next-month, .flatpickr-prev-month": {
        top: 15
      },
      "& .flatpickr-month:nth-of-type(1)": {
        borderRight: theme.flatpickr.monthDay.borderRight,
        marginLeft: "-3px",
        [`@media (max-width: ${breakpoints.md}px)`]: {
          borderRight: "none"
        },
      },
    },
    "& .flatpickr-calendar": {
      boxShadow: "none",
      [`@media (max-width: ${breakpoints.xs}px)`]: {
        maxWidth: "267px"
      },
    },
    "& .flatpickr-day.hidden":{
      visibility:"visible"
    },
    "& .flatpickr-day.prevMonthDay .flatpickr-day.nextMonthDay": {
      backgroundColor: theme.flatpickr.selected.backgroundColor,
      color: theme.flatpickr.day.color,
      fontSize: "14px",
      fontWeight: "400",
    },

    "& .flatpickr-day.prevMonthDay.hidden.selected.endRange": {
      backgroundColor: theme.flatpickr.selected.backgroundColor,
      color: theme.flatpickr.day.colorDefault,
      border:"none",
      fontSize: "14px",
      fontWeight: "400",
    },

    "& .flatpickr-day.nextMonthDay.hidden.selected.endRange": {
      backgroundColor: theme.flatpickr.selected.backgroundColor,
      color: theme.flatpickr.day.colorDefault,
      border:"none",
      fontSize: "14px",
      fontWeight: "400",
    },

    "& .flatpickr-day.prevMonthDay.hidden.selected.startRange": {
      backgroundColor: theme.flatpickr.selected.backgroundColor,
      color: theme.flatpickr.day.colorDefault,
      border:"none",
      fontSize: "14px",
      fontWeight: "400",
    },

    "& .flatpickr-day.nextMonthDay.hidden.selected.startRange": {
      backgroundColor: theme.flatpickr.day.backgroundColor,
      color: theme.flatpickr.day.colorDefault,
      border:"none",
      fontSize: "14px",
      fontWeight: "400",
    },


    "& .flatpickr-day":{
      fontFamily: theme.fontFamily,
      fontSize:"14px",
      fontWeight:"400",
      "&.selected":{
        backgroundColor: `${theme.flatpickr.selected.backgroundColor} !important`,
        borderColor: `${theme.flatpickr.selected.backgroundColor} !important`,
      },
      "&.today":{
        border:"none",
        fontWeight: "500",
        backgroundColor: theme.flatpickr.today.after.backgroundColor,
        "&:hover:after": {
          backgroundColor: theme.flatpickr.today.after.backgroundColor,
        },
        "&:hover":{
          color: theme.flatpickr.day.today.hover.color,
        }
      },
      "&:hover": {
        color: theme.flatpickr.day.today.hover.color,
        borderColor: theme.flatpickr.borderColor,
        background: theme.flatpickr.background,
      },
      "&:focus": {
        color: theme.flatpickr.day.today.hover.color,
        borderColor: theme.flatpickr.borderColor,
        background: theme.flatpickr.background,
      },
      "&.inRange": {
        boxShadow: theme.flatpickr.day.inRange.boxShadow,
        fontWeight: "500",
      }
    },
    "& .dayContainer":{
      padding:"0px 24px 20px 24px",
      [`@media (max-width: ${breakpoints.xs}px)`]: {
        padding:"0px 50px 5px 15px",
      },
    },
    "& .dayContainer:nth-of-type(1)":{
      borderRight: theme.flatpickr.monthDay.borderRight,
      [`@media (max-width: ${breakpoints.md}px)`]: {
        borderRight: "none"
      },
    },
    "& .flatpickr-weekdays": {
      height: "auto",
      "& .flatpickr-weekdaycontainer:nth-of-type(1)": {
        marginRight: "-2px"
      },
      "& .flatpickr-weekdaycontainer:nth-of-type(2)": {
        boxShadow: theme.flatpickr.weekday.boxShadow,
      },
    },
    "& .flatpickr-weekday": {
      color: theme.flatpickr.flatpickrWeekday.color,
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      fontFamily: "Inter"
    },
    "& .flatpickr-weekdaycontainer":{
      fontFamily: theme.fontFamily,
      fontSize:"14px",
      fontWeight:"500",
      padding:"18px 24px 18px 24px",
      [`@media (max-width: ${breakpoints.xs}px)`]: {
        padding:"15px 50px 5px 15px",
      },
    },
    "& .flatpickr-current-month":{
      fontFamily: theme.fontFamily,
      fontSize:"16px",
      fontWeight:"600",
      lineHeight:"24px",
      color: theme.flatpickr.currentMonth.color,
      "& .cur-month, .cur-year":{
        fontFamily: theme.fontFamily,
        fontSize:"16px",
        fontWeight:"600",
        lineHeight:"24px",
        color: theme.flatpickr.currentMonth.color,
      },
    },
    "& .flatpickr-day.today.startRange, .flatpickr-day.today.endRange": {
      color: theme.flatpickr.today.color,
      "&:after": {
        content: '""',
        display: "block",
        width: "6px",
        height: "6px",
        backgroundColor: theme.flatpickr.today.after.backgroundColor + "!important",
        borderRadius: "50%",
        position: "absolute",
        bottom: "4px",
        left: "16px",
      },
    },
    "& .flatpickr-day.selected.startRange, .flatpickr-day.selected.endRange": {
      fontWeight: "500",
      backgroundColor: theme.flatpickr.selected.backgroundColor,
      borderColor: theme.flatpickr.borderColor,
      "&:hover": {
        color: theme.flatpickr.today.color,
      },
    },
    "& .flatpickr-day.startRange, .flatpickr-day.endRange": {
      fontWeight: "500",
      backgroundColor: theme.flatpickr.selected.backgroundColor,
      borderColor: theme.flatpickr.borderColor,
      "&:hover": {
        color: theme.flatpickr.selected.hover.color,
      },
    },
    "& .flatpickr-day.today.selected:after": {
      backgroundColor: theme.flatpickr.today.after.backgroundColor,
    },
    "& .flatpickr-day.today:after": {
      content: '""',
      display: "block",
      width: "6px",
      height: "6px",
      backgroundColor: theme.flatpickr.today.after.default.backgroundColor,
      borderRadius: "50%",
      position: "absolute",
      bottom: "4px",
      left: "16px",
    },
  },
  popoverStyle:{
    maxWidth:"848px",
    width: "fit-content !important",
    height: "fit-content !important",
    border: "none",
    "& .popover-arrow": {
      display: "none !important",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      maxWidth: "360px"
    },
  },
  footer: {
    width: "100%",
    padding:"16px",
    borderTop: `1px solid ${colors.lightGrey}`,
    margin: "2px 10px 0px 0px"
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      padding:"0",
      marginTop: "10px",
      justifyContent: "normal"
    },
  },
  cancel: {
    height: "44px",
    padding: "10px 16px",
  },
  apply: {
    marginLeft: "10px",
    height: "44px",
    padding: "10px 16px",
  },
  selectedDates: {
    display: "flex",
    padding: 0,
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width:"100%"
    }
  },
  selectedDate: {
    flex: 1,
    border: theme.flatpickr.selectedDate.border,
    borderRadius: "8px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    padding: "10px 14px",
    minWidth: "100px",
    height: "44px",
    fontFamily: theme.fontFamily,
    fontSize:"16px",
    fontWeight:"400",
    lineHeight: "24px",
    color: theme.flatpickr.selectedDate.color,
  },
  separator: {
    display: "flex",
    alignItems: "center",
    margin: "0px 10px 0"
  },
  active: {
    backgroundColor: theme.flatpickr.active.backgroundColor,
  },
  buttonStyle: {
    padding:"10px 16px",
    extend: "filter",
    border: "none",
    textAlign: "left",
    "& span": {
      fontFamily: theme.fontFamily,
      fontSize:"14px",
      fontWeight:"500",
      lineHeight: "20px",
      color: colors.grey
    },
    "&:hover": {
      border: "none",
      background:colors.brightBlue,
    }
  },

  select: {
    display: "none",
    "& input": {
      display: "block"
    },
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      display: "block",
      marginTop: "8px",
      marginBottom: "8px"
    },
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      padding: "6px"
    },
  },
  buttonContainer:{
    padding:"12px 16px 12px 16px",
    width:"192px",
    display:"flex",
    flexDirection:"column",
    fontFamily: theme.fontFamily,
    fontSize:"14px",
    fontWeight:"500",
    lineHeight: "20px",
    color: colors.grey,
    borderRight:`1px solid ${colors.lightGrey}`,
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      display: "none"
    },
  }
}));

export default styles;

export const dateSelectOpen = {
  menu: (base) => ({
    ...base,
    zIndex: 4
  }),
}

